/**
 * TK-47 §1.5 (lee duyệt ý của bản ChatGPT v06) — CÂY "Tuyến & thiết bị" NGAY TRONG trang Vận hành: tuyến › tủ › đèn, có ô tìm.
 *   Bấm một dòng ⇒ gọi `onChon*` của trang, trang ghi CÙNG tham số URL `?tuyen=&tu=&den=` như chip tủ, chấm bản đồ, dòng bảng.
 *   Mở sẵn: tuyến đang chọn (và tủ đang chọn ⇒ đèn của tủ). Gõ tìm (không dấu cũng được) ⇒ hiện mọi tuyến / tủ / đèn khớp.
 *   Không câu giải thích; chấm trạng thái tủ: lá = trực tuyến, XÁM = mất kết nối.
 */
import { useMemo, useState } from 'react';
import { Search } from 'lucide-react';
import type { TreeRoute } from '../../lib/types';
import { khoaTim } from '../../lib/khongdau';
import { tenDen } from '../../lib/nemaNhan';
import type { DenBanDo } from '../nema/LopDenNema';
import { khoaDen } from './BangDenTuyen';

export function CayVanHanh({ cay, den, tuyenChon, tuChon, denChon, onChonTuyen, onChonTu, onChonDen, tieuDe = true }: {
  cay: TreeRoute[]; den: DenBanDo[];
  /** false ⇒ không vẽ tiêu đề riêng (ngăn kéo đã có tiêu đề "Tuyến & thiết bị") */
  tieuDe?: boolean;
  tuyenChon: string | null; tuChon: string | null; denChon: string | null;
  onChonTuyen: (id: string) => void; onChonTu: (id: string) => void; onChonDen: (d: DenBanDo) => void;
}) {
  const [tim, setTim] = useState('');
  const k = khoaTim(tim);
  const denTheoTu = useMemo(() => {
    const m = new Map<string, DenBanDo[]>();
    for (const d of den) { const a = m.get(d.cabinetId) ?? []; a.push(d); m.set(d.cabinetId, a); }
    for (const a of m.values()) a.sort((x, y) => x.addr - y.addr);
    return m;
  }, [den]);
  const khop = (s: string) => !k || khoaTim(s).includes(k);
  return (
    <section className="khoi flex min-h-0 flex-col rounded-the border border-vien bg-nen-1" data-o="cay-van-hanh" aria-label="Tuyến & thiết bị">
      {tieuDe && (
        <header className="flex items-center gap-2 border-b border-vien px-3 py-2.5">
          <div className="min-w-0"><span className="op-kicker">KHU VỰC ĐIỀU PHỐI</span><h2 className="m-0 mt-1 text-sm font-semibold text-chu-1">Tuyến & thiết bị</h2></div>
          <span className="op-dem" data-o="dem-tuyen">{cay.length}</span>
        </header>
      )}
      <label className="mx-3 my-2.5 flex min-h-[40px] items-center gap-2 rounded-nut border border-vien bg-nen-lom px-2.5">
        <Search className="h-4 w-4 shrink-0 text-chu-3" aria-hidden="true" />
        <input value={tim} onChange={(e) => setTim(e.target.value)} placeholder="Tìm tuyến, tủ, đèn" aria-label="Tìm tuyến, tủ, đèn"
          className="min-w-0 flex-1 bg-transparent text-sm text-chu-1 outline-none placeholder:text-chu-3" data-o="tim-cay" />
      </label>
      <ul className="m-0 min-h-0 flex-1 list-none overflow-y-auto px-1.5 pb-2" data-o="ds-cay">
        {cay.map((r) => {
          const dsTu = r.cabinets.filter((c) => khop(`${r.tenDayDu} ${c.name}`) || (denTheoTu.get(c.id) ?? []).some((d) => khop(tenDen(d))));
          if (k && dsTu.length === 0 && !khop(r.tenDayDu)) return null;
          const mo = r.id === tuyenChon || !!k;
          return (
            <li key={r.id}>
              <button type="button" onClick={() => onChonTuyen(r.id)} aria-pressed={r.id === tuyenChon} data-cay-tuyen={r.id} title={r.tenDayDu}
                aria-current={r.id === tuyenChon && !tuChon ? 'true' : undefined}
                className={`muc-cay flex w-full min-w-0 flex-col items-start rounded-nut px-2 py-1.5 text-left hover:bg-nen-2 ${r.id === tuyenChon && !tuChon ? 'bg-nen-2' : ''}`}>
                <span className="w-full truncate text-sm font-semibold text-chu-1">{r.tenDayDu}</span>
                <span className="text-xs tabular-nums text-chu-2">{r.cabinetCount} tủ · {r.onlineCount} trực tuyến</span>
              </button>
              {mo && (
                <ul className="m-0 ml-2 list-none border-l border-vien pl-1.5">
                  {(k ? dsTu : r.cabinets).map((c) => {
                    const on = c.status === 'ONLINE';
                    const dsDen = denTheoTu.get(c.id) ?? [];
                    const moTu = c.id === tuChon || (!!k && dsDen.some((d) => khop(tenDen(d))));
                    return (
                      <li key={c.id}>
                        <button type="button" onClick={() => onChonTu(c.id)} aria-pressed={c.id === tuChon} data-cay-tu={c.id} title={c.name}
                          aria-current={c.id === tuChon && !denChon ? 'true' : undefined}
                          className={`muc-cay flex min-h-[36px] w-full min-w-0 items-center gap-2 rounded-nut px-2 text-left text-sm hover:bg-nen-2 ${c.id === tuChon && !denChon ? 'bg-nen-2 text-chu-1' : 'text-chu-1'}`}>
                          <span className={`h-2 w-2 shrink-0 rounded-full ${on ? 'bg-tot' : 'bg-chu-3'}`} aria-hidden="true" />
                          <span className="min-w-0 flex-1 truncate">{c.name}</span>
                          <span className="shrink-0 text-xs tabular-nums text-chu-2">{dsDen.length} đèn</span>
                        </button>
                        {moTu && dsDen.length > 0 && (
                          <ul className="m-0 ml-3 list-none border-l border-vien pl-1.5">
                            {(k ? dsDen.filter((d) => khop(tenDen(d)) || khop(c.name)) : dsDen).map((d) => (
                              <li key={d.addr}>
                                <button type="button" onClick={() => onChonDen(d)} aria-pressed={khoaDen(d) === denChon} data-cay-den={khoaDen(d)} title={tenDen(d)}
                                  aria-current={khoaDen(d) === denChon ? 'true' : undefined}
                                  className={`muc-cay flex min-h-[32px] w-full min-w-0 items-center gap-2 rounded-nut px-2 text-left text-xs hover:bg-nen-2 ${khoaDen(d) === denChon ? 'bg-nen-2 text-chu-1' : 'text-chu-2'}`}>
                                  <span className="min-w-0 flex-1 truncate">{tenDen(d)}</span>
                                  <span className="shrink-0 tabular-nums">{d.dim == null ? '—' : `${d.dim} %`}</span>
                                </button>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    );
                  })}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
